export function fireAndForget(promise: Promise<any>): void {
    promise.then();
}
